__turbopack_context__.v({
  "compareWrapper": "Kzaqga_compareWrapper",
  "featureSectionHeader": "Kzaqga_featureSectionHeader",
  "infoIconContainer": "Kzaqga_infoIconContainer",
  "infoSection": "Kzaqga_infoSection",
  "loadingIndicator": "Kzaqga_loadingIndicator",
  "planHelperCopy": "Kzaqga_planHelperCopy",
  "planTitle": "Kzaqga_planTitle",
});
